import styled from "styled-components";

import {
  alignItemsCenter,
  flexColumn,
  rem,
  size,
} from "@styles/Utilities.styled";

import { StyledFullSurgicalHistoryModal } from "../FullSurgicalHistoryModal/FullSurgicalHistoryModal.styled";
import { medicalHistoryColors } from "../MedicalHistoryCard/MedicalHistoryCard.styled";

// prettier-ignore
export const StyledFullMedicalHistoryModal = styled(StyledFullSurgicalHistoryModal)`

  .timeline {
    &-item {
      align-items: start;

          &:last-child {
        .decor::before {
          content: none;
        }
      }

      .wrapper {
        ${flexColumn}

        span {
          line-height: 1;
        }
      }

      .tags {
        ${alignItemsCenter}
        gap: 0.5em;
        margin-top: 0.35rem;
        // outline: 1px solid red;

        span {
          font-size: ${rem(11)};
          font-weight: 500;
          padding: 0.2em 1em;
          border-radius: 100vmax;
          text-transform: capitalize;

          ${medicalHistoryColors}
        }
      }

      .decor::before {
        ${size("1px", rem(75))}
      }
    }
  }
`;
